import type { RawGraph } from "./types";

export interface Position {
  x: number;
  y: number;
}

const COLUMN_WIDTH = 280;
const ROW_HEIGHT = 110;

export function layoutGraph(graph: RawGraph, rootAddress: string): Map<string, Position> {
  const adjacency = new Map<string, string[]>();
  for (const edge of graph.edges) {
    if (!adjacency.has(edge.from)) adjacency.set(edge.from, []);
    adjacency.get(edge.from)!.push(edge.to);
  }

  const level = new Map<string, number>();
  level.set(rootAddress, 0);
  const queue = [rootAddress];
  while (queue.length > 0) {
    const current = queue.shift()!;
    const currentLevel = level.get(current)!;
    for (const next of adjacency.get(current) ?? []) {
      if (!level.has(next)) {
        level.set(next, currentLevel + 1);
        queue.push(next);
      }
    }
  }

  // Any node not reached by BFS (shouldn't normally happen) gets pushed to the far right
  // rather than silently dropped.
  const maxLevel = Math.max(0, ...level.values());
  for (const node of graph.nodes) {
    if (!level.has(node.address)) level.set(node.address, maxLevel + 1);
  }

  const countPerLevel = new Map<number, number>();
  const positions = new Map<string, Position>();

  for (const node of graph.nodes) {
    const lvl = level.get(node.address)!;
    const row = countPerLevel.get(lvl) ?? 0;
    countPerLevel.set(lvl, row + 1);
    positions.set(node.address, { x: lvl * COLUMN_WIDTH, y: row * ROW_HEIGHT });
  }

  return positions;
}
